"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const lighthouse_config_1 = require("../../lighthouse.config");
exports.default = async (sourcePath, authToken) => {
    try {
        const endpoint = `${lighthouse_config_1.lighthouseConfig.lighthouseDataDepot}/api/upload/upload_files`;
        const FormData = eval(`require`)('form-data');
        const fs = eval(`require`)('fs');
        const formData = new FormData();
        formData.append('file', fs.createReadStream(sourcePath));
        const response = await axios_1.default.post(endpoint, formData, {
            maxContentLength: Infinity,
            maxBodyLength: Infinity,
            headers: {
                ...formData.getHeaders(),
                Authorization: `Bearer ${authToken}`,
            },
        });
        return { data: response.data.message };
    }
    catch (error) {
        throw new Error(error);
    }
};
